namespace Nobox.NoBoxCRM {
    export interface FormresultsListRequest extends Serenity.ListRequest {
        Tags?: string[];
    }
}
